import React from "react";

function About() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="position-relative pt-sm-8 pt-lg-9 pb-0 overflow-hidden">

        <div className="position-absolute top-0 end-0 z-index-2 mt-7 me-n9 d-none d-md-block">
          <img src="assets/images/elements/grad-shape/05.png" className="rotate-180" alt="" />
        </div>

        <div className="position-absolute top-0 start-0 ms-n4 mt-7">
          <img src="assets/images/elements/grad-shape/blur-decoration.svg" className="blur-7 opacity-1" alt="Grad shape" />
        </div>

        <div className="container position-relative z-index-2 pt-4 pb-5 pb-lg-8">
          <nav className="mb-2" aria-label="breadcrumb">
            <ol className="breadcrumb pt-0">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">About us</li>
            </ol>
          </nav>

          <h1>Building a Better</h1>
          <h6 className="display-1"><span className="text-primary">Future</span> Together</h6>

          <div className="d-lg-flex justify-content-end align-items-start gap-3 mt-4 mt-sm-5">
            <p className="inner-container-small border-purple border-2 border-start mx-0 ps-2">
              With a rich history of innovation and technology, the Arix Automation team is dedicated to transforming ideas into digital masterpieces. Join us on our journey as we continue to push the boundaries of software and deliver excellence in every project we undertake.
            </p>
            <a className="btn btn-light icon-link icon-link-hover mt-2" href="/team">
              Meet our team<i className="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>

        <div className="bg-secondary-grad position-relative pb-5 pb-lg-8 px-2 px-md-5">
          <div className="bg-body blur-5 h-300px w-100 position-absolute top-0 start-0 mt-n5"></div>
          {/* style string → JSX object (fix #1) */}
          <div
            className="h-300px h-md-500px h-xl-700px z-index-2 position-relative rounded-4"
            style={{
              background: "url(assets/images/bg/03.jpg) no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "top",
            }}
          ></div>
        </div>
      </section>

      {/* ===================== CLIENTS LOGOS ===================== */}
      <section className="bg-secondary-grad pt-1">
        <div className="container">
          <div className="row g-4">

            <div className="col-md-7 mb-3 mb-md-0">
              <h3 className="mb-4 mb-sm-5 pe-7">Join over <span className="text-purple">1,000+</span> companies using Arix Automation</h3>
              <div className="d-flex flex-wrap gap-4 gap-sm-5">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <div className="swap-logo" key={n}>
                    <img src={`assets/images/client/logo-gray/0${n}.svg`} className="h-30px" alt="client-img" />
                    <div className="swap-item">
                      <img src={`assets/images/client/logo-light/0${n}.svg`} className="dark-mode-item h-30px" alt="client logo" />
                      <img src={`assets/images/client/logo-dark/0${n}.svg`} className="light-mode-item h-30px" alt="client logo" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

         

          </div>
        </div>
      </section>

      {/* ===================== HISTORY / SINCE 2002 ===================== */}
      <section className="bg-secondary-grad pt-0 pb-1">
        <div className="container position-relative z-index-2">
          <div className="row">
            <div className="col-xl-10 mx-auto">
              <div className="row align-items-center g-4 g-lg-6 mb-6 mb-md-8">

                <div className="col-sm-8 col-lg-5 position-relative mx-auto">
                  {/* style string → JSX object (fix #2) */}
                  <div
                    className="text-bg-img text-center text-lg-start fw-bold lh-1"
                    style={{
                      background: "url(assets/images/about/text-bg.jpg) no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      WebkitBackgroundClip: "text",
                      backgroundClip: "text",
                    }}
                  >
                    2023
                  </div>
                  <h5 className="bg-body px-4 py-2 position-absolute top-0 start-0 rotate-335">Since</h5>
                </div>

                <div className="col-lg-7">
                  <h2 className="mb-4">Bringing ideas to life</h2>
                  <p>At Arix Automation, our experts blend innovation with strategy to turn your vision into reality.</p>
                  <p className="mb-4">
                    We believe great technology is strategic. Our approach combines industry knowledge with creative
                    insights to ensure your digital presence is impactful and results-driven.
                  </p>
                  <ul className="list-inline d-flex flex-wrap gap-2 gap-sm-4 mb-3">
                    <li className="list-inline-item heading-color">
                      <i className="bi bi-check-circle text-primary-grad me-1"></i>Creative design
                    </li>
                    <li className="list-inline-item heading-color">
                      <i className="bi bi-check-circle text-primary-grad me-1"></i>Strategic insight
                    </li>
                  </ul>
                  <a className="btn btn-white-shadow mb-0 mt-3" href="/services">Explore our services</a>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="max-width-1550 bg-dark position-relative rounded-4 py-5 py-sm-6 py-lg-8 mb-n9" data-bs-theme="dark">
            <div className="container">
              <div className="row">
                <div className="col-lg-5">
                  <h2 className="mb-4 mb-sm-6">Our awards and achievements</h2>
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
                    <div className="col">
                      <img src="assets/images/elements/fwa-light.svg" className="h-30px mb-3" alt="award logo" />
                      <p className="mb-0">Digital vanguard award</p>
                    </div>
                    <div className="col">
                      <img src="assets/images/elements/clutch-light.svg" className="h-30px mb-3" alt="award logo" />
                      <p className="mb-0">Best website of the week</p>
                    </div>
                    <div className="col">
                      <img src="assets/images/elements/webby.svg" className="h-30px mb-3" alt="award logo" />
                      <p className="mb-0">5X developer awards</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 ms-auto position-absolute bottom-0 end-0 d-none d-lg-block">
                  <img src="assets/images/elements/awards-saly.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===================== TIMELINE SLIDER ===================== */}
      <section className="pt-9 overflow-hidden">
        <div className="container pt-6 pt-sm-8">

          <div className="row mb-md-5">
            <div className="col-sm-8 col-md-7 col-lg-5">
              <h2>A legacy of creativity and growth</h2>
            </div>
            <div className="col-sm-3 col-md-4 ms-auto">
              <div className="d-flex justify-content-end gap-2 position-relative">
                <a href="#" className="btn btn-lg btn-secondary btn-icon rounded-circle mb-0 swiper-button-prev">
                  <i className="bi bi-arrow-left"></i>
                </a>
                <a href="#" className="btn btn-lg btn-secondary btn-icon rounded-circle mb-0 swiper-button-next">
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <div
            className="swiper swiper-step swiper-outside-end-n20"
            data-swiper-options='{"spaceBetween":0,"loop":true,"autoplay":false,"navigation":{"nextEl":".swiper-button-next","prevEl":".swiper-button-prev"},"breakpoints":{"576":{"slidesPerView":1},"768":{"slidesPerView":3},"992":{"slidesPerView":3},"1200":{"slidesPerView":4}}}'
          >
            <div className="swiper-wrapper">
              {[
                { period: '2023 - The Beginning', text: 'It was founded with a vision to revolutionize the visual design industry. Starting as a small team of passionate designers, we set out to deliver creative solutions that make a difference.' },
                { period: '2024 - Growth and innovation', text: 'We expanded our capabilities, refined our creative process, and continued delivering high-impact digital experiences for clients.' },
                { period: '2025 - Scaling new heights', text: 'Our commitment to quality and innovation drove strong growth and helped us strengthen our position as a trusted industry partner.' },
                { period: '2026 - Building the future', text: 'With a vision for the future, we are exploring new opportunities, expanding our services, and continuing to deliver exceptional solutions that inspire and engage.' },
              ].map((item, i) => (
                <div className="swiper-slide" key={i}>
                  <div className="swiper-step-divider"></div>
                  <div className="card card-body bg-secondary bg-opacity-50 p-4 me-2 me-sm-5">
                    <h6 className="text-primary">{item.period}</h6>
                    <p className="mb-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ===================== TESTIMONIALS GRID ===================== */}
      <section className="position-relative overflow-hidden py-0">
        <div className="bg-body blur-6 h-300px w-100 position-absolute bottom-0 start-0 z-index-2 mb-n6"></div>

        <div className="container position-relative mb-n5">
          <div className="text-center mb-4 mb-md-5">
            <h2 className="mb-4">Trusted by industry leaders</h2>
            <ul className="avatar-group align-items-center justify-content-center mb-2">
              {['02', '05', '10', '09', '06'].map((n) => (
                <li className="avatar avatar-sm" key={n}>
                  <img className="avatar-img rounded-circle" src={`assets/images/avatar/${n}.jpg`} alt="avatar" />
                </li>
              ))}
            </ul>
            <p>Rated <span className="badge bg-primary">4.9/5.0</span> by over 100.000+ users</p>
          </div>

          <div className="row g-4">
            {[
              { avatar: '09.jpg', name: 'Jay Patel', handle: '@jaqmilr56', text: 'Their team went above and beyond to understand our needs and deliver a solution that exceeded our expectations. They demonstrated throughout the process was truly impressive.', date: 'Feb 22, 2024' },
              { avatar: '02.jpg', name: 'Krunal Sharma', handle: '@fregulois2589', text: 'Frequently partiality possession resolution at or appearance unaffected me. Ye goodness felicity do disposal dwelling no.', date: 'Jan 28, 2024' },
              { avatar: '06.jpg', name: 'Sameer Mishra', handle: '@samshop', text: 'Two before narrow not relied on how except moment myself. Dejection assurance Mrs led certainly. So gate at no only none open. Betrayed.', date: 'Jan 28, 2024' },
              { avatar: '04.jpg', name: 'Dimple Khatri', handle: '@Emson589', text: 'Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child. The bore of true of no be deal.', date: 'Jan 21, 2024' },
              { avatar: '05.jpg', name: 'Dhanajay Trivedi', handle: '@smith4u', text: 'Working with this team has been an absolute pleasure. They took the time to understand our vision and delivered beyond our expectations. The creativity and professionalism they bring to the table are unmatched.', date: 'Jan 21, 2024' },
              { avatar: '08.jpg', name: 'Monil Dave', handle: '@Davischhotu', text: 'Our passion for customer excellence is just one reason why we are the market leader. We have always worked very hard to give our customers the best experience.', date: 'Jan 21, 2024' },
              { avatar: '01.jpg', name: 'Sarah Brown', handle: '@Brownmunde', text: 'Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child. The bore of true of no be deal.', date: 'Jan 21, 2024' },
              { avatar: '08.jpg', name: 'Allen Smith', handle: '@smith4u', text: 'Working with this team has been an absolute pleasure. They took the time to understand our vision and delivered beyond our expectations. The creativity and professionalism they bring to the table are unmatched.', date: 'Jan 21, 2024' },
              { avatar: '02.jpg', name: 'Michael Davis', handle: '@Davischhotu', text: 'Our passion for customer excellence is just one reason why we are the market leader. We have always worked very hard to give our customers the best experience.', date: 'Jan 21, 2024' },
            ].map((t, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div className="card border rounded-4 p-3 m-0">
                  <div className="card-header d-flex justify-content-between pb-0">
                    <div className="d-flex align-items-center">
                      <div className="avatar flex-shrink-0">
                        <img className="avatar-img rounded-circle" src={`assets/images/avatar/${t.avatar}`} alt="avatar" />
                      </div>
                      <div className="ms-3">
                        <p className="heading-color fw-semibold mb-0">{t.name}</p>
                        <small>{t.handle}</small>
                      </div>
                    </div>
                    <a href="#" className="heading-color fs-5"><i className="bi bi-twitter-x"></i></a>
                  </div>
                  <div className="card-body">
                    <blockquote>
                      <p>{t.text}</p>
                    </blockquote>
                    <span className="small text-body-secondary">{t.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>

      {/* ===================== CTA ===================== */}
      <section className="pt-6 pt-sm-5">
        <div className="container">
          <div className="bg-secondary-grad position-relative rounded-3 overflow-hidden p-4 p-sm-6">

            <div className="position-absolute end-0 top-0 rotate-343 mt-n5 me-7 d-none d-sm-block">
              <img src="assets/images/elements/geo-grad-pattern.svg" className="h-500px opacity-3" alt="bg pattern" />
            </div>
            <div className="position-absolute start-0 top-0 rotate-343 mt-n5 ms-n8">
              <img src="assets/images/elements/geo-grad-pattern.svg" className="h-300px opacity-1" alt="bg pattern" />
            </div>

            <div className="row g-4 align-items-center position-relative">
              <div className="col-xl-6">
                <h2>Ready to bring your <span className="text-primary-grad">vision</span> into life?</h2>
                <ul className="list-inline d-flex flex-wrap gap-2 mb-0 mt-3">
                  <li className="list-inline-item heading-color">
                    <i className="bi bi-check-circle text-success me-1"></i>Free Prototype
                  </li>
                  <li className="list-inline-item heading-color">
                    <i className="bi bi-check-circle text-success me-1"></i>Delivery in 72 hours
                  </li>
                </ul>
              </div>
              <div className="col-xl-6 text-xl-end">
                <a href="/contact" className="btn btn-dark mb-0">Let's work together</a>
              </div>
            </div>

          </div>
        </div>
      </section>

    </main>
  );
}

export default About;
